import { useContext, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import useOffer from "../../api/hooks/useOffers";
import { logMsgBgColors } from "../../consts/misc";
import { toIcons } from "../../consts/Paths";
import MainContext from "../../context/MainContext";
import useIsMobile from "../../hooks/useIsMobile";
import { Model } from "../../interfaces";
import { offerRemappingFromResult } from "../../utils/offerRemapping";

const ModelPageTopButton = (props: any) => {
  const { isMobile } = useIsMobile();
  const navigate = useNavigate();
  const { modelSelector, offer, setOffer, setModel, token } =
    useContext(MainContext);
  const { RESPONSES, RESULTS, CTAs } = useOffer();

  const { onModelSelection, modelList, setModelList } = modelSelector;

  const save = (list: Model[]) => {
    const id = offer?.id;
    let finalObj = offer;
    if (list.length > 0) {
      let models_id_array: number[] = [];
      list.forEach((model: Model) => {
        models_id_array.push(model.id);
      });
      /* console.log(models_id_array); */
      finalObj = { ...offer, models_proposed_list: models_id_array };
    }
    /* console.log(finalObj, id); */
    CTAs.updateOffer(id!, finalObj);
  };
  useEffect(() => {
    /* console.log(RESPONSES.updateResponse, RESULTS.updateResult);  */
    if (RESPONSES.updateResponse?.ok) {
      props.logMessage.write("subject", "Offer ");
      props.logMessage.write("other_text", "has been updated ");
      props.logMessage.write("complement", "successfully!");
      props.logMessage.write("bgColor", logMsgBgColors.correct);
      const remappedOffer = offerRemappingFromResult(RESULTS.updateResult.data);
      setOffer(remappedOffer);
      setTimeout(() => {
        navigate(`/offers/${offer?.id}`);
      }, 2000);
    } else if (RESPONSES.updateResponse?.ok === false) {
      props.logMessage.write("subject", "Offer");
      props.logMessage.write("other_text", " could not be deleted");
      props.logMessage.write("bgColor", logMsgBgColors.error);
    }
  }, [RESPONSES.updateResponse]);

  const handleAddModel = () => {
    setModelList(modelList);
    setModelList([]);
    save(modelList);
  };

  const handleNewModel = () => {
    setModel(null);
    navigate(`/models/create`);
  };

  return (
    <button
      className="add-button"
      style={{ width: isMobile ? (onModelSelection ? "56px" : "66px") : "" }}
      disabled={
        onModelSelection &&
        (props.modelSelectedQuantity <= 0 || modelList.length <= 0)
      }
      type="button"
      onClick={() => {
        onModelSelection ? handleAddModel() : handleNewModel();
      }}
    >
      {!onModelSelection ? (
        <div>
          {isMobile ? (
            <img className=" white" src={`${toIcons}/plus.svg`} />
          ) : (
            <p className="add-buttonText"> Add Model</p>
          )}
        </div>
      ) : (
        <p className="add-buttonText">
          {`${isMobile ? "+ " : "Add"} ${props.modelSelectedQuantity} ${
            isMobile ? "" : "model"
          }${props.modelSelectedQuantity > 1 && !isMobile ? "s" : ""}`}
        </p>
      )}
    </button>
  );
};
export default ModelPageTopButton;
